import { computed, ref, reactive, toRefs } from '@vue/composition-api'
import targetblank from 'showdown-target-blank'

const showdown = require('showdown');
const converter = new showdown.Converter({ extensions: [targetblank] });


export default function useMarkdown() {

    const htmlToMarkdown = (html) => {
        if (!html) return "";

        return converter.makeMarkdown(html);
    }

    const markdownToHtml = (markdown) => {

        if (!markdown) return "";

        return converter.makeHtml(markdown);
    }

    return {
        htmlToMarkdown,
        markdownToHtml
    }
}
